import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import useMobileLayout from './use-mobile-layout';
type MobileViewport = {
  height: number;
  top: number;
  keyboardOpen: boolean;
};

// Toolbars collapsing change the visible height by far less than a software keyboard takes.
const KEYBOARD_MIN_HEIGHT = 150;
const useMobileViewport = () => {
  const $ = _c(3);
  const isMobile = useMobileLayout();
  const [viewport, setViewport] = useState();
  let t0;
  let t1;
  if ($[0] !== isMobile) {
    t0 = () => {
      const visualViewport = window.visualViewport;
      if (!isMobile || !visualViewport) {
        return;
      }
      const update = () => {
        if (visualViewport.scale > 1) {
          return;
        }
        setViewport({
          height: visualViewport.height,
          top: visualViewport.offsetTop,
          keyboardOpen: document.documentElement.clientHeight - visualViewport.height > KEYBOARD_MIN_HEIGHT
        });
      };
      update();
      visualViewport.addEventListener("resize", update);
      visualViewport.addEventListener("scroll", update);
      return () => {
        visualViewport.removeEventListener("resize", update);
        visualViewport.removeEventListener("scroll", update);
      };
    };
    t1 = [isMobile];
    $[0] = isMobile;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  return isMobile ? viewport : undefined;
};
export default useMobileViewport;